/**
 * The destinations the redesigned site sends people to but does not own.
 *
 * One module because the same URL is needed from more than one place and drifting copies are how a
 * footer ends up disagreeing with a page: the donor app is asked for by the Contact page and by the
 * footer's "WebApp" and "Certificates" entries. They were separate placeholders until TEC-3821.
 *
 * The NGO AREA is deliberately not here. It is not a fixed URL: `useNgoAreaUrl` derives it from the
 * host the visitor is on, so a link followed from `snd` stays in `snd` instead of jumping to
 * production. The application form below is a fixed URL, which is why it can live here.
 */

/** What a donor can answer for themselves: donation status and tax certificate. */
export const DONOR_APP_URL = 'https://app.worldcoo.com';

/** Open positions. Worldcoo publishes them on LinkedIn, not on the site. */
export const JOBS_URL = 'https://www.linkedin.com/company/worldcoo/jobs/';

/**
 * Where an entity applies to collaborate: the Google Form the NGO team reads applications from.
 *
 * Four CTAs open it: the partner-NGOs page's "Únete a Worldcoo" and "Darse de alta", the Contact
 * page's "Ir al formulario", and the footer's "Alta de ONG". It is NOT the NGO area's own onboarding —
 * `useNgoAreaUrl` serves the CTAs for an entity that is already inside, its login and its own area
 * among them, and the FAQ's answer about signing up, which is the last one still pointing there.
 */
export const NGO_APPLICATION_FORM_URL =
	'https://docs.google.com/forms/d/e/1FAIpQLSc3pM2f0XBePXX-c60VjkWxWqIAghe3f2R-a1hr3ldwkuI_1A/viewform';
